import ReactDOM from 'react-dom';
import { useState } from 'react';
import { AppContextProvider } from '../../Services/AppContext';
import { loadDOMComponent } from '../../helpers';
import OrderPatientButton from './OrderPatientButton';

loadDOMComponent({
	selector: 'react-order-patient-button',
	callback: ({ container }) => {
		const workplaceId = container.getAttribute('workplaceId');
		const patientId = container.getAttribute('patientId');
		const caseId = container.getAttribute('caseId');
		const className = container.getAttribute('className');
		ReactDOM.render(
			<AppContextProvider>
				<OrderPatientButton
					patientId={patientId}
					workplaceId={workplaceId}
					caseId={caseId}
					className={className}
				/>
			</AppContextProvider>,
			container,
		);
	},
});
